import React from 'react';
import {   Table, Icon, List, Popup } from 'semantic-ui-react';
import { Link } from "react-router-dom";


const DescuentoRow=({descuento, onShowModalBorrar, onShowModalActivar, color,form, permisos,consultar})=>{
    return (
    <Table.Row>
                        <Table.Cell>{descuento.descripcion}</Table.Cell>
                        <Table.Cell textAlign="center">{descuento.fechaVigencia}</Table.Cell>
                        <Table.Cell textAlign="center">{descuento.estatus}</Table.Cell>
                        <Table.Cell textAlign="center">
                            <List horizontal>
                                <List.Item>
                                    <Link to={"/descuento/"+descuento.id}> 
                                     <Popup
                                        trigger={<Icon  name='edit outline' link   size="large"  color="tela" ></Icon>}
                                        content='Editar'
                                       
                                      />
                                     </Link> 
                                    
                                </List.Item>
                                <List.Item>
                                    <Popup
                                        trigger={
                                            <Icon name='trash alternate outline' link 
                                            onClick={()=>onShowModalBorrar(descuento.id)} 
                                            size="large" color="red"  />
                                        }
                                        content='Borrar'
                                      />
                                </List.Item>
                                <List.Item>
                                    <Popup
                                        trigger={
                                            <Icon name={descuento.idEstatus==1?'x':'check'} link  size="large" 
                                                color={descuento.idEstatus==1?"orange":"green"}  
                                                onClick={()=>onShowModalActivar(descuento.id)} 
                                            />
                                        }
                                        content={descuento.idEstatus==1?'Inactivar':'Activar'}
                                      />  
                                    
                                </List.Item>
                                <List.Item>
                                    <Popup
                                        trigger={
                                            <Icon name='download' link 
                                            onClick={()=>consultar(descuento.id)} 
                                            size="large" color="green"  />
                                        }
                                        content='Descargar cupones'
                                      />
                                </List.Item>      
                                      
                                      
                            </List>
                    </Table.Cell>
                      
        </Table.Row>
    
    )
}


export default DescuentoRow;